import { api } from 'api'
import { useMutation, useQueryClient } from '@tanstack/react-query'
import { toaster } from 'uikit/Toaster'

export const useChangeIDXState = (id: string) => {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: (isDisable: boolean) => {
      if (isDisable) {
        return api.users.disableIDX(id)
      } else {
        return api.users.enableIDX(id)
      }
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['userCard'] })
    },
    onError: (err: any) => {
      toaster.create({
        type: 'error',
        title: 'Произошла ошибка при изменении IDX',
        description: err.response?.data?.message || err.message,
      })
    },
  })
}
